import { createContext, useReducer } from "react";

export const AuthContext = createContext();

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':

            return {...state, data: action.payload};
            
            break;
        
    
        default:
            return state
            break;
    }

}

export function AuthContextProvider({children}) {
    let authString = localStorage.getItem("auth");
    let data = authString && authString !== "undefined" ? JSON.parse(authString) : {};

    const [state, dispatch] = useReducer(authReducer, {
        data
    });


    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            {children}

        </AuthContext.Provider>
    )
}

;